import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {
    AiOutlineClose,
    AiOutlineCreditCard,
    AiOutlineDownload,
    AiOutlineEdit,
    AiOutlineMail,
} from 'react-icons/ai';
import {
    FlexiButton,
    FlexiCancelButton
} from "@flexinet/ui-components";
import {useVerifiedPermissions} from "@flexinet/auth-components";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {useInvoice} from "./useInvoice.ts";
import {useState} from "react";

export const useEditPageTools = () => {

        const {id: invoiceId} = useParams()

        const {
            record,
            handleSend,
            handleVoid
        } = useInvoice(invoiceId);


        const navigate = useNavigate();

        const {allowedActions} = useVerifiedPermissions()

        const [drawerOpened, setDrawerOpened] = useState(false);

        const tools = [];

        if (allowedActions.includes(rbacActions.UpdateInvoice)) {
            tools.push(<FlexiButton key={'download'}
                                    onClick={() => {
                                        window.open(record?.invoicePdf);
                                    }}
                                    leftSection={<AiOutlineDownload/>}
                                    disabled={!record?.invoicePdf}
            >Download</FlexiButton>);
        }

        if (allowedActions.includes(rbacActions.UpdateInvoice)) {
            tools.push(<FlexiButton key={'pay'}
                                    onClick={() => {
                                        window.open(record?.hostedInvoiceUrl);
                                    }}
                                    leftSection={<AiOutlineCreditCard/>}
                                    disabled={record?.status !== 'open'}
            >Pay</FlexiButton>);
        }

        if (allowedActions.includes(rbacActions.UpdateInvoice)) {
            tools.push(<FlexiButton key={'send'}
                                    onClick={() => {
                                        handleSend();
                                        navigate(`/invoices`)
                                    }}
                                    leftSection={<AiOutlineMail/>}
            >Send</FlexiButton>);
        }

        if (allowedActions.includes(rbacActions.UpdateInvoice)) {
            tools.push(<FlexiButton key={'void'}
                                    onClick={() => {
                                        handleVoid();
                                        navigate(`/invoices`)
                                    }}
                                    leftSection={<AiOutlineClose/>}
                                    disabled={record?.status !== 'open'}
            >Void</FlexiButton>);
        }

        if (allowedActions.includes(rbacActions.UpdateInvoice)) {
            tools.push(<FlexiButton leftSection={<AiOutlineEdit/>} variant={'filled'} key={'edit'}
                                    onClick={() => setDrawerOpened(true)}
                                    disabled={record?.status !== 'draft'}
            >Edit</FlexiButton>);
        }

        tools.push(<FlexiCancelButton key={'close'}
                                      onClick={() => navigate(`/invoices`)}>Close</FlexiCancelButton>);


        return {
            drawerOpened,
            setDrawerOpened,
            tools,
        };

    }
;
